import React, { ReactNode, useState } from 'react';
import { RuleSet } from 'styled-components';
import { Typography } from '../Typography';
import { TooltipContainer, TooltipWrapper } from './styled';

interface TooltipProps {
  text: string;
  children: ReactNode;
  wrapperWidth?: number;
  wrapperHeight?: number;
  tooltipTopSpace: number;
  styles?: RuleSet<object>;
  disabled?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({
  text,
  children,
  wrapperWidth,
  wrapperHeight,
  tooltipTopSpace,
  styles,
  disabled = false
}) => {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = () => {
    if (!disabled) {
      setVisible(true);
    }
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  const handleClick = () => {
    if (visible) {
      handleMouseLeave();
    }
  };

  return (
    <TooltipWrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      $wrapperWidth={wrapperWidth}
      $wrapperHeight={wrapperHeight}
    >
      {children}
      <TooltipContainer
        $isVisible={visible}
        data-cy="tooltip"
        $tooltipTopSpace={tooltipTopSpace}
        $styles={styles}
      >
        <Typography tag="body_1">{text}</Typography>
      </TooltipContainer>
    </TooltipWrapper>
  );
};
